// extracted by mini-css-extract-plugin
export default {"main":"Waa-z"};